import { RouteObject } from "react-router-dom";
import Landing from "./components/landing/landing";

export interface assetClassificationRoute
  extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: assetClassificationRoute[];
}

export const assetClassificationRoutes: assetClassificationRoute[] = [
  {
    path: "/ax/settings/asset-classification",
    element: <Landing />,
  },
];